module.exports = __webpack_public_path__ + "img/logo_full.9fe6e506.png";